export const ACCEPTED_FILE_TYPES = {
  VIDEO: ".mp4",
  IMAGE: ".jpg, .svg, .jpeg, .png, .gif",
};

export const UPLOAD_FORMATS = {
  GIF: "GIF",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
};

export const DISPLAY_CONTEXT = {
  FORM: "FORM",
  DRAWER: "DRAWER",
};

export const REDIRECT_URL_REGEX =
  /^(https?:\/\/)?([\w\u0600-\u06FF-]+\.)*[\w\u0600-\u06FF-]{2,}\.[a-z\u0600-\u06FF]{2,}(\/[\w\u0600-\u06FF-.,@?^=%&:/~+#]*)?$/;
